// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__NZnwL","question":"FAQ_question__BGtCA","answer":"FAQ_answer__CV9+y"};